import React from "react";
import { Form, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ResponseApiCalls } from "../../apis/ResponseApiCalls";
import { Spin } from "../standardization/YuJaLoading";
import { useCookie } from "../../hooks/useCookie";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {
    VIEWER_USER_TYPE
} from "../../utils/constants";
import { notifyError } from "../../utils/helpers";
import YuJaButton from "../standardization/YuJaButton";
import { YuJaTextBox } from "../standardization/YuJaTextBox";
import { useTranslation } from "react-i18next";


export default function AnonyJoinPollNameRequiredModal({ modalShow, setModalShow, name, setName, pollCode, nameRequired = false }) {
    const { t } = useTranslation();
    const isLoading = false;
    const history = useHistory();
    const {setUserNameToLocalStorage} = ResponseApiCalls();
    const [setCookie, , ] = useCookie("name", "Guest");

    const handleJoin = async () => {
        let nameTrimmed = name.trim();
        if (nameRequired && nameTrimmed === "") {
            notifyError(t("poll.disableAnonymousWarning"));
            return;
        } else {
            setCookie(nameTrimmed);
            setUserNameToLocalStorage(pollCode, nameTrimmed, VIEWER_USER_TYPE.MANUAL_GUEST);
            history.push("/join/" + pollCode);
        }
    };

    const handleClose = () =>{
        setName("");
        setModalShow(false);
    };

    return (
        <Modal
            id="form-modal"
            show={modalShow}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
        >
            <Spin tip="Loading..." size="large" spinning={isLoading}>
                <ModalClose onClick={handleClose} className="modal-close" />
                <Modal.Header
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Modal.Title className="warning-title" id="contained-modal-title-vcenter">{t("poll.joinModalTitle")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="customized-form" onSubmit={e => e.preventDefault()}>
                        <Form.Group style={{ marginBottom: "0.938rem" }}>
                            <Form.Label className="form-label">{t("poll.joinModalNameRequiredLabel")}</Form.Label>
                            <YuJaTextBox
                                containerStyle={{width: "90%", fontSize: 15}}
                                value={name || ""}
                                onChange={(e) => setName(e.target.value)}
                                placeholder={t("poll.pleaseEnterName")}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="join-poll-modal-footer">
                    <div style={{flex: 1}}/>
                    <YuJaButton type="secondary"  onClick={handleClose}>{t("common.cancel")}</YuJaButton>
                    <YuJaButton onClick={handleJoin}>{t("poll.joinModalEnterPollButton")}</YuJaButton>
                </Modal.Footer>
            </Spin>
        </Modal>)
}
